<template>
  <div>
    <layout :isSuccess="true">
      <template v-slot:headZone>
        <parent-bar></parent-bar>
      </template>
      <template v-slot:containerZone>
        <PermissionValidation
          :marketId="marketId"
          rule="enableViewApprove"
        >
          <approve-layout
            :marketId="marketId"
          >
            <router-view
              :isMainLoading="isLoading"
              @onGetApproveTasksByMarket="getApproveTasksByMarket"
              @onGetApproveTasksSettingHistoryByMarket="onGetApproveTasksSettingHistoryByMarket"
            ></router-view>
          </approve-layout>
        </PermissionValidation>
      </template>
    </layout>
  </div>
</template>

<script>
import ApproveList from "../../components/ApproveList.vue";
import ApproveLayout from "../../components/ApproveLayout.vue";
import Headline from "../../components/Headline.vue";
import Layout from "../../components/Layout.vue";
import ParentBar from "../../components/ParentBar.vue";
import PermissionValidation from "../../components/PermissionValidation.component.vue";
export default {
  components: {
    Headline,
    Layout,
    ParentBar,
    ApproveList,
    ApproveLayout,
    PermissionValidation
  },
  computed: {
    admin() {
      return this.$store.getters["admin/getByMarketId"](this.marketId);
    },
  },
  data() {
    return {
      isLoading: false,
      marketId: this.$route.params.marketId
    };
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      this.getApproveTasksByMarket();
    },
    async getApproveTasksByMarket(subTypes) {
      try {
        this.isLoading = true;
        await this.$store.dispatch("approveTask/getApproveTasksByMarket", {
          marketId: this.$route.params.marketId,
          status: ["pending"]
        });
        this.isLoading = false;
      } catch (e) {
        this.$toast.show({
          content: e.message,
          color: "error"
        });
      }
    },
    async onGetApproveTasksSettingHistoryByMarket(form) {
      try {
        this.isLoading = true;
        await this.$store.dispatch(
          "approveTask/getApproveTasksSettingHistoryByMarket",
          {
            marketId: this.$route.params.marketId,
            status: ["rejected", "approved"],
            ...form
          }
        );
        this.isLoading = false;
      } catch (e) {
        this.$toast.show({
          content: e.message,
          color: "error"
        });
      }
    }
  }
};
</script>

<style>
</style>